import React from 'react';
import format from './../../utilities/format';
import { IMAGE_CDN } from '../../constants/constants';
import translate from '../../utilities/translator';

export default function PriceGraphPlaceholder(props) {
  const { nights, destination } = props;
  return (
    <div className="c-row">
      <div className="col-lg-12">
        <div className="price-graph price-graph--loading">
          <div className="price-graph__header">
            <img src={`${IMAGE_CDN}/price-graph.png`} alt="" />
            <div>
              <div className="price-graph__title">
                {translate("holidayFinder.priceGraph.title_desktop")}
              </div>
              <div
                className="price-graph__subtitle"
                dangerouslySetInnerHTML={{
                  __html: translate("holidayFinder.priceGraph.subtitle_desktop", {
                    nights,
                    destination: `<b>${destination.name}</b>`,
                    month: `<b>${format(
                      new Date(),
                      "MMMM"
                    )}</b>`,
                  }),
                }}
              />
            </div>
          </div>
          <div className="price-graph__loader" />
        </div>
      </div>
    </div>
  );
}
